export default __webpack_public_path__ + "static/media/IndexPrompt.a651ca6e.jpg";